import { render, staticRenderFns } from "./Classroom.vue?vue&type=template&id=07cab404"
import script from "./Classroom.vue?vue&type=script&lang=js"
export * from "./Classroom.vue?vue&type=script&lang=js"
import style0 from "./Classroom.vue?vue&type=style&index=0&id=07cab404&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports